import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralCopyToClipboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 22,
	viewBox: "0 0 19 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.33301 4.75V4C4.33301 2.34315 5.67615 1 7.33301 1H14.6663C16.3232 1 17.6663 2.34315 17.6663 4V14.6667C17.6663 16.3235 16.3232 17.6667 14.6663 17.6667H14.333",
		stroke: "#FF3131"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 4.33203,
		width: 13.3333,
		height: 16.6667,
		rx: 3,
		stroke: "#FF3131"
	})]
});
export default SvgReferralCopyToClipboard;
